import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"
import FeatherIcon from "feather-icons-react"

const TrustBadgesSection = () => {
    const { t } = useTranslation()

    const badges = [
        { icon: "shield", label: "KVKK Uyumlu" },
        { icon: "lock", label: "SSL Güvenli" },
        { icon: "server", label: "On-Premise" },
        { icon: "cloud", label: "Bulut Seçeneği" },
        { icon: "headphones", label: "7/24 Destek" },
        { icon: "check-circle", label: "ISO 27001" },
    ]

    return (
        <section className="py-4 bg-light border-bottom">
            <Container>
                <Row className="justify-content-center align-items-center">
                    {badges.map((badge, key) => (
                        <Col
                            lg={2}
                            md={4}
                            xs={6}
                            key={key}
                            className="text-center py-3"
                        >
                            <div className="d-flex flex-column align-items-center">
                                <div
                                    className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center mb-2"
                                    style={{ width: "50px", height: "50px" }}
                                >
                                    <FeatherIcon
                                        icon={badge.icon}
                                        className="text-primary"
                                        style={{ width: "24px", height: "24px" }}
                                    />
                                </div>
                                <small className="text-muted fw-medium">{badge.label}</small>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default TrustBadgesSection
